module.exports = __webpack_public_path__ + "img/N339-1.4c1dd6fa.png";